import React from "react";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import "../../styles/Patient-ui/Patient-home.css";
import "../../styles/Patient-ui/Patient-Sidebar.css";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { COOKIE_KEYS } from "../../App";
import { useChatContext } from "../../context/ChatContext";

function SideBar(props) {
  const navigate = useNavigate();
  const { stompObject, setStompObject, setIsLoggedIn } = useChatContext();

  const handleLogout = () => {
    Cookies.remove(COOKIE_KEYS.userId);
    Cookies.remove(COOKIE_KEYS.token);
    Cookies.remove(COOKIE_KEYS.userType);

    if (stompObject) {
      stompObject.disconnect(() => console.log("Disconnected from WebSocket."));
      setStompObject(null);
      setIsLoggedIn(false);
    }
    navigate("/");
  };

  const iconBox = (node) => (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '24px',
      height: '24px'
    }}>
      {node}
    </div>
  );

  return (
    <div className="sb-root">
      <Sidebar
        className="sb-sidebar"
        backgroundColor="var(--youro-sage)"
        collapsed={false}
        width="84px"
        rootStyles={{borderRight: '1px solid rgba(255, 255, 255, 0.1)'}}
      >
        <div className="sb-brand" onClick={() => props.setActive(0)}>
          <span className="sb-brand-text">
            <h1 style={{margin: 0, fontFamily: "'Nunito', sans-serif", fontSize: '1.5rem', fontWeight: 700, color: '#ffffff', textTransform: 'lowercase'}}>youro</h1></span>
        </div>

        <Menu
          className="sb-menu"
          menuItemStyles={{
            button: ({ active }) => ({
              height: "48px",
              width: "48px",
              margin: "0 auto 16px auto",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: active ? "var(--youro-mint)" : "transparent",
              color: active ? "var(--youro-sage)" : "#ffffff",
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: active ? "var(--youro-mint)" : "rgba(255,255,255,0.1)",
              },
            }),
            icon: () => ({ marginRight: 0 }),
            label: () => ({ display: "none" }),
          }}
        >
          <MenuItem
            onClick={() => props.setActive(0)}
            active={props.active === 0}
            icon={iconBox(<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path><path d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path></svg>)}
          />

          <MenuItem
            onClick={() => props.setActive(1)}
            active={props.active === 1}
            icon={iconBox(<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 2v4"></path><path d="M16 2v4"></path><rect width="18" height="18" x="3" y="4" rx="2"></rect><path d="M3 10h18"></path></svg>)}
          />

          <MenuItem
            onClick={() => props.setActive(2)}
            active={props.active === 2}
            icon={iconBox(
              <div className="sb-chat-wrap">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"></path></svg>
                {props.count > 0 && (
                  <span className="sb-badge">{props.count}</span>
                )}
              </div>
            )}
          />

          <MenuItem
            onClick={() => props.setActive(3)}
            active={props.active === 3}
            icon={iconBox(<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 7v14"></path><path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path></svg>)}
          />

          <MenuItem
            onClick={() => props.setActive(5)}
            active={props.active === 5}
            icon={iconBox(<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"></path><path d="m8.5 8.5 7 7"></path></svg>)}
          />
        </Menu>

        <div className="sb-spacer" />

        {/* optional logout at bottom (only if you want later)
        <div className="sb-bottom">
          <button className="sb-logout" onClick={handleLogout}>Logout</button>
        </div>
        */}
      </Sidebar>
    </div>
  );
}

export default SideBar;